import './Nav.css';
import React, {FunctionComponent} from 'react';
import styles from "./Nav.module.css";
import logo from "../../../img/camparator-402x100.png";
import {Link} from "react-router-dom";

export const Nav: FunctionComponent = () => {
    return (
        <nav className={"navbar navbar-expand-md navbar-light fixed-top bg-light " + styles.navbar}>
            <div className="container-fluid">
                <Link className={"navbar-brand"} to="/">
                    <img className={styles.brandImage} src={logo} alt="Camparator"/>
                </Link>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse"
                        data-bs-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false"
                        aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"/>
                </button>
                <div className="collapse navbar-collapse" id="navbarCollapse">
                    <ul className="navbar-nav me-auto">
                        <li className="nav-item">
                            <Link className={"nav-link"} to="/">
                                Home
                            </Link>
                        </li>
                        <li className="nav-item dropdown">
                            <button type="button" className="btn btn-link nav-link dropdown-toggle" id="navbarActive"
                                    data-bs-toggle="dropdown" aria-expanded="false">
                                Active
                            </button>
                            <ul className="dropdown-menu" aria-labelledby="navbarActive">
                                <li>
                                    <Link className={"dropdown-item"} to="/compare/cam/">
                                        Cams
                                    </Link>
                                </li>
                                <li>
                                    <Link className={"dropdown-item"} to="/compare/ballnut/">
                                        Ball Nuts
                                    </Link>
                                </li>
                                <li>
                                    <hr className="dropdown-divider"/>
                                </li>
                                <li>
                                    <Link className={"dropdown-item"} to="/compare/active/">
                                        All Active
                                    </Link>
                                </li>
                            </ul>
                        </li>
                        <li className="nav-item dropdown">
                            <button type="button" className="btn btn-link nav-link dropdown-toggle" id="navbarPassive"
                                    data-bs-toggle="dropdown" aria-expanded="false">
                                Passive
                            </button>
                            <ul className="dropdown-menu" aria-labelledby="navbarPassive">
                                <li>
                                    <Link className={"dropdown-item"} to="/compare/nut/">
                                        Nuts
                                    </Link>
                                </li>
                                <li>
                                    <Link className={"dropdown-item"} to="/compare/hex/">
                                        Hexes
                                    </Link>
                                </li>
                                <li>
                                    <Link className={"dropdown-item"} to="/compare/tricam/">
                                        Tricams
                                    </Link>
                                </li>
                                <li>
                                    <Link className={"dropdown-item"} to="/compare/bigbro/">
                                        Big Bros
                                    </Link>
                                </li>
                                <li>
                                    <hr className="dropdown-divider"/>
                                </li>
                                <li>
                                    <Link className={"dropdown-item"} to="/compare/passive/">
                                        All Passive
                                    </Link>
                                </li>
                            </ul>
                        </li>
                        <li className="nav-item">
                            <Link className={"nav-link"} to="/app/">
                                App
                            </Link>
                        </li>
                    </ul>
                    <ul className="navbar-nav">
                        <li className="nav-item">
                            <button className="btn btn-link nav-link" data-bs-toggle="modal" data-bs-target="#settingsModal">
                                <span className="d-inline d-sm-none">Settings </span>
                                <i className="fa fa-cog" aria-hidden="true"/>
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    )
}
